import React from "react";
import { useAtom } from "jotai";
import { settingsAtom } from "../utils/atoms";
import TeacherHomePage from "./HomePage";
import HomePageSix from "./HomePageSix";
import AccessDeniedPage from "./AccessDeniedPage";

const DashboardEntrypoint = () => {
    const [settings] = useAtom(settingsAtom);
    const userType = settings?.user?.type;

    if (!userType) return null; // or a loading spinner

    if (userType === "teacher" || userType === "dio") {
        return <TeacherHomePage />;
    }
    if (userType === "student") {
        return <HomePageSix />;
    }
    // Add more user types as needed
    return <AccessDeniedPage />;
};

export default DashboardEntrypoint; 